import { combineReducers } from 'redux';
import { ALL_LANGUAGES } from 'models/constants';
import { ActionType } from 'store/ActionType';
import {
    ChangeAvailableLanguagesActionType,
    PreferredLanguageFetchRequestActionType,
    PreferredLanguageFetchSuccessActionType,
    PreferredLanguageFetchFailureActionType,
} from './languageAction';

const initialAvailableLanguagesState = ALL_LANGUAGES;

const availableLanguages = (state: string[] = initialAvailableLanguagesState, action: ActionType) => {
    switch (action.type) {
        case ChangeAvailableLanguagesActionType: {
            return action.payload;
        }
        default: {
            return state;
        }
    }
};

const changePreferredLanguageIsFetching = (
    state = false,
    action: ActionType,
) => {

    switch (action.type) {
        case PreferredLanguageFetchRequestActionType: {
            return true;
        }
        case PreferredLanguageFetchSuccessActionType:
        case PreferredLanguageFetchFailureActionType: {
            return false;
        }
        default: {
            return state;
        }
    }
};

export default combineReducers({
    availableLanguages,
    changePreferredLanguageIsFetching,
});
